import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { VTooltip } from 'v-tooltip';

VTooltip.options.defaultClass = 'pendo-tooltip';
VTooltip.options.defaultBoundariesElement = 'viewport';
VTooltip.options.defaultHtml = false;
function buildClassList(_ref) {
  let {
    classes,
    multiline,
    arrow,
    theme
  } = _ref;
  const classList = ['pendo-tooltip'];
  if (typeof classes === 'string') {
    classList.push(...classes.split(' '));
  }
  if (Array.isArray(classes)) {
    classList.push(...classes);
  }
  if (multiline) {
    classList.push('is-multi-line');
  }
  if (arrow) {
    classList.push('has-tooltip-arrow');
  }
  if (theme) {
    classList.push(`pendo-tooltip--${theme}`);
  }
  return [...new Set(classList)];
}
const bind = function (unboundFn) {
  return function (el, _ref2) {
    let {
      value
    } = _ref2;
    if (typeof value !== 'object') {
      return unboundFn(...arguments);
    }
    if (value.offset == null) {
      value.offset = 8;
    }
    value.classes = buildClassList(value).join(' ');
    if (value.disposeTimeout) {
      VTooltip.options.disposeTimeout = value.disposeTimeout;
    } else {
      VTooltip.options.disposeTimeout = 2000;
    }
    return unboundFn(...arguments);
  };
}(VTooltip.bind);
const PendoTooltip = _objectSpread2(_objectSpread2({}, VTooltip), {}, {
  bind,
  update: bind
});
var PendoTooltip$1 = PendoTooltip;

export { PendoTooltip, buildClassList, PendoTooltip$1 as default };
//# sourceMappingURL=pendo-tooltip.js.map
